import { reactive } from 'vue';

const loadingState = reactive({
  isLoading: false, 
});

export const LoadingService = {
  get isLoading() {
    return loadingState.isLoading;
  },
  show() {
    loadingState.isLoading = true;
  },
  hide() {
    loadingState.isLoading = false;
  },
  toggle() {
    loadingState.isLoading = !loadingState.isLoading;
  },
};
